import { setIsCheckboxChecked } from "../../../CheckboxAgreement/slice";
import { handleCatalogCheckboxToggle } from "./analytics";
export var handleCheckboxToggleAnalytics = function handleCheckboxToggleAnalytics() {
  return function (dispatch) {
    dispatch(setIsCheckboxChecked());
    dispatch(handleCatalogCheckboxToggle());
  };
};